import type { ComponentChildren } from "preact";

export type HeaderTabProps = {
  href: string;
  isActive?: boolean;
  children: ComponentChildren;
  class?: string;
};

const BASE = "flex flex-col items-center justify-center gap-1 px-3 py-2 text-xs font-medium transition-colors border-b-2";
const ACTIVE = "text-neutral-700 dark:text-neutral-100 border-blue-600";
const INACTIVE = "text-neutral-500 dark:text-neutral-400 border-transparent hover:text-neutral-700 dark:hover:text-neutral-300";

/** A tab in the mobile header; the page puts them there with `useHeaderActions`. */
export const HeaderTab = ({ href, isActive = false, children, class: className = "" }: HeaderTabProps) => (
  <a href={href} class={`${BASE} ${isActive ? ACTIVE : INACTIVE} ${className}`.trim()}>
    <span>{children}</span>
  </a>
);
